import React, { Component } from "react";
import { BASE_URL } from "../../static/constants";
import Form from "./Form";
import Snackbar from "@mui/material/Snackbar";
import MySnackbarContentWrapper from "../AppPage/SnackBar";
import logo from "./static/SmallLogo.png";
import { showErrorToast, showSuccessToast } from "utils/toast";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: null,
      loading: false,
      authToken: null,
      snackbarOpen: false,
      snackbarError: false,
      snackbarMessage: null,
      passwordChanged: false,
    };

    this.onSubmitReset = this.onSubmitReset.bind(this);
  }

  closeSnackBar() {
    this.setState({
      snackbarOpen: false,
    });
  }

  onSubmitReset(password) {
    const token = window.location.pathname?.split("/")?.pop();

    this.setState({
      alertMessage: null,
      loading: true,
    });
    fetch(`${BASE_URL}/user/resetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        new_password: password,
        reset_token: token,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          loading: false,
        });
        if (result.error) {
          throw Error(result.message);
        }
        showSuccessToast("Password Updated");
        this.setState({
          passwordChanged: true,
        });
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      })
      .catch((error) => {
        const errorStr = error.toString();
        this.setState({
          alertMessage: errorStr,
        });
        showErrorToast(errorStr);
      });
  }

  render() {
    const {
      alertMessage,
      loading,
      snackbarError,
      snackbarMessage,
      snackbarOpen,
      passwordChanged,
    } = this.state;
    return (
      <div>
        <div style={{ textAlign: "center", marginTop: 100 }}>
          <img style={{ width: 200 }} src={logo} alt="logo" />
        </div>
        <Form
          loading={loading}
          alertMessage={alertMessage}
          onSubmitReset={this.onSubmitReset.bind(this)}
          passwordChanged={passwordChanged}
        />

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarError ? "error" : "success"}
            message={snackbarMessage}
          />
        </Snackbar>
      </div>
    );
  }
}

export default Login;
